export type CityType = 'capital' | 'costera' | 'interior';
export type FaqItem = { q: string; a: string };

export const CITY_TYPE_MAP: Record<string, CityType> = {
  'malaga': 'capital',
  'marbella': 'costera',
  'fuengirola': 'costera',
  'torremolinos': 'costera',
  'benalmadena': 'costera',
  'mijas': 'costera',
  'estepona': 'costera',
  'velez-malaga': 'costera',
  'rincon-de-la-victoria': 'costera',
  'nerja': 'costera',
  'benahavis': 'costera',
  'san-pedro-de-alcantara': 'costera',
  'cartama': 'interior',
  'alhaurin-de-la-torre': 'interior',
  'alhaurin-el-grande': 'interior',
  'antequera': 'interior',
  'coin': 'interior',
  'alora': 'interior',
  'ronda': 'interior',
};

export const FAQS_CAPITAL_PERSIANAS = (name: string, barrios: string[]): FaqItem[] => [
  {
    q: `¿Cuánto cuesta reparar una persiana en ${name} capital?`,
    a: `En ${name} capital la reparación básica cuesta desde 60€ (cinta), 80€ (motor genérico) o 150€ (sustitución completa). El presupuesto incluye desplazamiento dentro del término municipal y revisión sin compromiso.`,
  },
  {
    q: `¿Trabajáis en barrios como ${barrios.slice(0, 3).join(', ')}?`,
    a: `Sí, cubrimos todos los barrios de ${name}: ${barrios.join(', ')} y zonas limítrofes. Conocemos las particularidades de cada distrito, desde edificios históricos del centro hasta urbanizaciones modernas.`,
  },
  {
    q: `¿En cuánto tiempo llegáis si vivo en ${name} centro?`,
    a: `Para urgencias en el casco urbano de ${name}, llegamos en menos de 4 horas si nos contactas antes de las 14h. Para reparaciones programadas, visita garantizada en 24h con presupuesto cerrado el mismo día.`,
  },
  {
    q: `¿Cómo afecta la humedad marina de ${name} a las persianas?`,
    a: `La proximidad al mar acelera la corrosión de motores y guías metálicas. En ${name} recomendamos mantenimiento preventivo cada 18-24 meses y motores con protección anti-salinidad para alargar su vida útil.`,
  },
  {
    q: `¿Puedo dejar la llave en portería para que reparéis sin estar en casa?`,
    a: `Sí, trabajamos habitualmente con porterías y conserjes en edificios de ${name}. Tras presupuesto aprobado, coordinamos la entrada y enviamos parte detallado con fotos del antes/después.`,
  },
  {
    q: `¿Tenéis taller físico en ${name}?`,
    a: `Sí, nuestro taller está en Calle Pacífico 54, San Andrés, 29003 ${name}. Puedes visitarnos con cita previa para ver muestras de motores, lamas y persianas antes de decidir.`,
  },
];

export const FAQS_COSTERA_PERSIANAS = (name: string, barrios: string[]): FaqItem[] => [
  {
    q: `¿Cuánto afecta el salitre marino de ${name} a las persianas?`,
    a: `En ${name}, la cercanía al mar oxida motores y deteriora guías de aluminio 2-3 veces más rápido que en el interior. Recomendamos motores con tratamiento anti-salinidad y revisión cada 18 meses.`,
  },
  {
    q: `¿Trabajáis en urbanizaciones cerradas de ${name}?`,
    a: `Sí, atendemos urbanizaciones cerradas y comunidades de ${name}, incluyendo ${barrios.slice(0, 2).join(' y ')}. Coordinamos accesos con conserjes y respetamos normativas comunitarias de horarios.`,
  },
  {
    q: `¿Reparáis persianas de apartamentos turísticos en ${name}?`,
    a: `Sí, somos especialistas en apartamentos vacacionales de ${name}. Servicio express en 24h para minimizar pérdida de noches alquiladas. Emitimos factura deducible como gasto del alquiler turístico.`,
  },
  {
    q: `¿Qué persiana recomendáis para primera línea de playa en ${name}?`,
    a: `Aluminio lacado con motor estanco IP44. El PVC se degrada por la radiación UV reflejada del mar y el aluminio sin lacar pierde color en 2-3 años en zona costera.`,
  },
  {
    q: `¿Cuál es el plazo de respuesta en ${name} en temporada alta?`,
    a: `Incluso en julio y agosto mantenemos visita en 24h en ${name}. Reforzamos equipo durante temporada alta porque un apartamento sin persiana operativa pierde ingresos cada noche.`,
  },
  {
    q: `¿Tengo que estar presente durante la reparación en ${name}?`,
    a: `No es obligatorio. Si tu vivienda en ${name} está vacía, coordinamos con vecinos, conserje o llave depositada. Enviamos fotos detalladas del trabajo y factura por email.`,
  },
];

export const FAQS_INTERIOR_PERSIANAS = (name: string, barrios: string[]): FaqItem[] => [
  {
    q: `¿Llegáis hasta ${name} desde Málaga capital?`,
    a: `Sí, cubrimos ${name} con desplazamiento incluido si la reparación supera 80€. Vamos a ${name} 2-3 veces por semana, agrupar visitas con vecinos puede acelerar el plazo y reducir costes.`,
  },
  {
    q: `¿Qué persianas resisten mejor el calor extremo de ${name} en verano?`,
    a: `En ${name}, donde las temperaturas superan los 38°C en verano, recomendamos persianas de aluminio con cámara de aire aislante. Mejoran el confort interior 5-8°C y reducen consumo de aire acondicionado hasta un 30%.`,
  },
  {
    q: `¿Tenéis tarifa especial para cortijos y casas de campo de ${name}?`,
    a: `Para fincas rústicas y cortijos en ${name} ofrecemos presupuesto por conjunto de persianas (5+) con descuento. Trabajamos también persianas exteriores tipo mallorquina típicas de ${name} y su comarca.`,
  },
  {
    q: `¿Cuánto cuesta el desplazamiento a ${name}?`,
    a: `El desplazamiento a ${name} está incluido en el presupuesto si la reparación supera 80€. Para visitas de diagnóstico sin trabajo posterior, cobramos 25€ de desplazamiento (reembolsable si contratas).`,
  },
  {
    q: `¿Trabajáis con persianas antiguas de madera en ${name}?`,
    a: `Sí, en cascos históricos de ${name} es habitual encontrar persianas mallorquinas o de librillo de madera. Las restauramos respetando la estética original o las sustituimos por modelos modernos con apariencia tradicional.`,
  },
  {
    q: `¿Reparáis persianas en pueblos cercanos a ${name}?`,
    a: `Sí, desde ${name} cubrimos también pueblos limítrofes. Pregúntanos por tu localidad al 951 12 07 70, agrupamos visitas en la misma jornada para optimizar tiempos.`,
  },
];

export const FAQ_PACKS_PERSIANAS: Record<CityType, (name: string, barrios: string[]) => FaqItem[]> = {
  'capital': FAQS_CAPITAL_PERSIANAS,
  'costera': FAQS_COSTERA_PERSIANAS,
  'interior': FAQS_INTERIOR_PERSIANAS,
};

export function getFaqsForCity(slug: string, name: string, barrios: string[]): FaqItem[] {
  const type = CITY_TYPE_MAP[slug] || 'interior';
  return FAQ_PACKS_PERSIANAS[type](name, barrios || []);
}